<template>
  <div 
    class="scroller" 
    data-animated
  >
    <ul class="scroller__inner" :class="{ 'slow-animation': !isDesktop, 'fast-animation': isDesktop }">
      <slot></slot>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // speed: "fast",
      // direction: "left",
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    }
  },
  mounted() {
    this.addAnimation();
  },
  methods: {
    addAnimation() {
        const scroller = this.$el;
        const scrollerInner = scroller.querySelector(".scroller__inner");
        const scrollerContent = Array.from(scrollerInner.children);
        const itemCount = scrollerContent.length;
        // const itemsNeeded = 10 - itemCount;

        // if (itemsNeeded > 0) {
        //   for (let i = 0; i < itemsNeeded; i++) {
        //     scrollerContent.forEach((item) => {
        //       const duplicatedItem = item.cloneNode(true);
        //       duplicatedItem.setAttribute("aria-hidden", true);
        //       scrollerInner.appendChild(duplicatedItem);
        //     });
        //   }
        // }

        scroller.setAttribute("data-animated", true);
    }
  }
};
</script>

<style>
.scroller:hover .scroller__inner {
  animation-play-state: paused;
}

.scroller {
  width: 100%;
}
.scroller__inner {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.scroller .scroller__inner {
  width: max-content;
  flex-wrap: nowrap;
  animation: scroll var(--_animation-duration, 10s)
}

.slow-animation {
  --_animation-duration: 70s;
}

.fast-animation {
  --_animation-duration: 30s; 
}

/* .scroller[data-direction="right"] {
  --_animation-direction: reverse;
}

.scroller[data-direction="left"] {
  --_animation-direction: forwards;
} */

@keyframes scroll {
  to {
    transform: translate(calc(-50% - 0.5rem));
  }
}

@media (max-width: 576px){
  .ticker-img {
    display: none;
  }
}

</style>
